// @react/hooks/useBilling.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingStore } from '@core/stores';

/**
 * React hook for Account operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBilling } from '@react/hooks';
 *
 * const AccountList = observer(() => {
 *   const store = useBilling();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBilling() {
  return billingStore;
}
